<div *ngIf="loading.isLoading">
  <app-loading [loadingText]="loading.message"></app-loading>
</div>

<div class="error-container" *ngIf="!loading.isLoading && loadError">

  <app-load-error [loadError]="loadError">
  </app-load-error>

</div>